import React from 'react';
import {
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
  DropdownMenuItem,
} from '@/modern/components/ui/dropdown-menu';
import { eventStyles, STRIPED_TASK_STYLE } from '@/other/constants/TaskTypes';
import { Task } from '@/bryntum-lib/models/Task';
import { TaskStylePreview } from './TaskStylePreview';

interface TaskStylePickerProps {
  record: Task;
  onStyleChange?: (style: string) => void;
  disabled?: boolean;
}

const allStyles = [...eventStyles, STRIPED_TASK_STYLE];

export const TaskStylePicker: React.FC<TaskStylePickerProps> = ({ record, onStyleChange, disabled }) => {
  const currentStyle = record?.taskStyle || eventStyles[0];
  const taskColor = record?.color || '#FF8A65'; // Fallback color

  const handleStyleSelect = (style: string, event: Event) => {
    event.preventDefault(); // Prevent menu from closing
    if (record) {
      record.taskStyle = style;
    }
    onStyleChange?.(style);
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger disabled={disabled}>
        <i className="fa-light fa-palette w-4 h-4" />
        <span>Task Style</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-56">
        {allStyles.map((style) => (
          <DropdownMenuItem
            key={style}
            onSelect={(event) => handleStyleSelect(style, event)}
            className="p-2"
          >
            <TaskStylePreview style={style} isSelected={currentStyle === style} color={taskColor} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};